import { type } from "os";
import React, { useContext, useState, useEffect, BaseSyntheticEvent } from "react";
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { ChatCompletionRequestMessage, ChatCompletionRequestMessageRoleEnum, Configuration, CreateChatCompletionRequest, CreateChatCompletionResponse, OpenAIApi } from "openai";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { requireValidateion } from "../../common/Valitation";
import { TextareaAutosize, TextField } from "@mui/material";
import { OnsiteProgress } from "../../customelements/CustomInput";
import styled from "styled-components";

type ResponseParam = {

}

type RequestParam = {

}

type TagData = {
    tags: string[],
    context: string,
}

export type IFormInputs = {
    sendMessage: string
}

const schema = Yup.object({
    sendMessage: requireValidateion
}).required();

const Button = styled.button`
background: transparent;
border-radius: 3px;
border: 2px solid #BF4F74;
color: #BF4F74;
margin: 0 1em;
padding: 0.25em 1em;
`;

const cssTable = styled.table`
border: 2px solid #BF4F74;
`;

export const Supportchat = () => {

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [requestMessage, setRequestMessage] = useState<ChatCompletionRequestMessage[]>([]);
    const [openaiResponse, setOpenaiResponse] = useState<CreateChatCompletionResponse>();
    const [openaiResponseList, setOpenaiResponseList] = useState<CreateChatCompletionResponse[]>([]);
    const [openaiResponseSingleLang, setOpenaiResponseSingleLang] = useState<CreateChatCompletionResponse>();
    const [openaiResponseSingleLangList, setOpenaiResponseSingleLangList] = useState<CreateChatCompletionResponse[]>([]);
    const [debugTagList, setDebugTagList] = useState<TagData[]>();
    const [openaiRequestParam1, setOpenaiRequestParam1] = useState<CreateChatCompletionRequest>({
        model: "",
        messages: []
    });
    const [openaiRequestParam2, setOpenaiRequestParam2] = useState<CreateChatCompletionRequest>({
        model: "",
        messages: []
    });

    const wordCount: number = 5;
    const systemPrompt = `文章からキーワード単語${wordCount}つ以内で抽出して箇条書きすること。出力する単語は名詞化する。箇条書き以外の返信は必要なし。形式は次の通り。・回答A\n・回答B\n・回答C\n`;
    const anserSystemPrompt = 'あなたは質問に回答するAIアシスタントです。';

    const tags: TagData[] = [
        { tags: ['有償', '画像認識'], context: 'ライセンスコードを購入し、ライセンス認証を行って頂くことで有償機能をご利用頂けます。' },
        { tags: ['画像認識'], context: '指定した画像の有無の判定を行い、動作の分岐を行うことができます。' },
        { tags: ['価格', 'ライセンス', 'price'], context: '価格は年間30000円です。' },
        { tags: ['マニュアル'], context: 'マニュアルは以下のURLからダウンロードできます。' },
        { tags: ['スマホ', '携帯'], context: '携帯電話のミラーリングソフトを利用する事で可能です。' }
    ];

    const configuration = new Configuration({
        apiKey: process.env.REACT_APP_OPENAI_KEY,
    });

    const { register, handleSubmit, trigger, control, getValues, watch, formState: { errors, isValid } } = useForm<IFormInputs>({
        defaultValues: {
            sendMessage: ""
        },
        reValidateMode: "onSubmit",
        mode: "onSubmit",
        resolver: yupResolver(schema),
    });

    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs, event?: BaseSyntheticEvent) => {
        await requestOpenAi(data.sendMessage);
    }

    const getTagData = function (messageList: (string | undefined)[]): TagData[] {
        const result = tags.filter((tag) => {
            //alert(`tag:${tag.context}`);
            return tag.tags.some((innerTag) => {
                //alert(`innerTag:${innerTag}`);
                return messageList?.some((messsgae) => {
                    //alert(`message:${messsgae}\ninnerTag:${innerTag}\n${messsgae?.indexOf(innerTag)}`);
                    if (messsgae === undefined) {
                        return false;
                    }
                    return messsgae?.indexOf(innerTag) > -1;
                })
            })
        });
        //alert(result.length);
        result.forEach((value) => {
            alert(`result:${value.context}`);
        });

        return result;
    }

    const openai = new OpenAIApi(configuration);

    useEffect(() => {

    }, []);

    const requestOpenAi = async function (addMessage: string) {
        //requestMessage.push({ role: ChatCompletionRequestMessageRoleEnum.User, content: addMessage });
        alert(1);
        setIsLoading(value => { return true });

        setOpenaiRequestParam1(value => {
            return {
                model: "gpt-3.5-turbo",
                //messages: requestMessage,
                messages: [
                    { role: ChatCompletionRequestMessageRoleEnum.System, content: systemPrompt },
                    { role: ChatCompletionRequestMessageRoleEnum.User, content: `次の文章から重要単語を${wordCount}つ以内で抽出しなさい:${addMessage}` }
                ]
            }
        });

        const response = await openai.createChatCompletion(openaiRequestParam1/*{
            model: "gpt-3.5-turbo",
            messages: [
                { role: ChatCompletionRequestMessageRoleEnum.System, content: systemPrompt },
                { role: ChatCompletionRequestMessageRoleEnum.User, content: `次の文章から重要単語を${wordCount}つ以内で抽出しなさい:${addMessage}` }
            ]
        }*/).then((value) => {
            setOpenaiResponseSingleLang(value.data);
            setOpenaiResponseSingleLangList((current) => {return [...current, value.data]});
            return value.data;
        }).finally(() => {
            setIsLoading(value => { return false });
        });
        alert(2);

        const resposeList = response.choices.map((field, index) => {
            return field.message?.content;
        });
        alert(3);

        const tagList = getTagData(resposeList);
        setDebugTagList(value => { return tagList });

        setIsLoading(value => { return true });

        setOpenaiRequestParam2((value) => {
            return {
                model: "gpt-3.5-turbo",
                messages: [
                    { role: ChatCompletionRequestMessageRoleEnum.System, content: anserSystemPrompt },
                    { role: ChatCompletionRequestMessageRoleEnum.User, content: `${addMessage}\n検索した結果、次の回答が見つかっています。不要な回答も含まれている可能性があります。この中から回答を生成してください。 ${resposeList.join(',')}` }
                ]
            }
        });

        const answerResponse = await openai.createChatCompletion(openaiRequestParam2).then((value) => {
            setOpenaiResponse(state => { return value.data })
            setOpenaiResponseList(state => {return [...state, value.data]})
            return value.data;
        }).finally(() => {
            setIsLoading(value => { return false });
        });
        alert(4);
    }

    return (
        <>
            <table>
                <thead>
                    <tr>
                        <th colSpan={2}>最新のレスポンス</th>
                        <th>ロール</th>
                        <th>メッセージ</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        openaiResponseSingleLangList.map((field, index) => {
                            return field.choices.map((inField, inIndex) => {
                                if (inIndex == 0) {
                                    return (
                                        <>
                                            <tr>
                                                <td colSpan={2} style={{ backgroundColor: "aqua" }}></td>
                                            </tr>
                                            <tr>
                                                <td>{inField.message?.role}</td>
                                                <td>{inField.message?.content}</td>
                                            </tr>
                                        </>
                                    )
                                } else {
                                    return (
                                        <>
                                            <tr>
                                                <td>{inField.message?.role}</td>
                                                <td>{inField.message?.content}</td>
                                            </tr>
                                        </>
                                    )
                                }
                            })
                        })
                    }
                </tbody>
            </table>

            <table>
                <thead>
                    <tr>
                        <th colSpan={2}>レスポンス</th>
                        <th>ロール</th>
                        <th>メッセージ</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        openaiResponseList.map((field, index) => {
                            return field.choices.map((inField, inIndex) => {
                                if (inIndex == 0) {
                                    return (
                                        <>
                                            <tr>
                                                <td colSpan={2} style={{ backgroundColor: "aqua" }}></td>
                                            </tr>
                                            <tr>
                                                <td>{inField.message?.role}</td>
                                                <td>{inField.message?.content}</td>
                                            </tr>
                                        </>
                                    )
                                } else {
                                    return (
                                        <>
                                            <tr>
                                                <td>{inField.message?.role}</td>
                                                <td>{inField.message?.content}</td>
                                            </tr>
                                        </>
                                    )
                                }
                            })
                        })
                    }
                </tbody>
            </table>

            <table>
                <thead>
                    <tr>
                        <th colSpan={2}>最新のレスポンス</th>
                        <th>ロール</th>
                        <th>メッセージ</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        openaiResponseSingleLang?.choices.map((field, index) => {
                            return (
                                <>
                                    <tr>
                                        <td style={{ backgroundColor: "lime" }}>{field.message?.role}</td>
                                        <td style={{ backgroundColor: "lime" }}>{field.message?.content}</td>
                                    </tr>
                                </>
                            );
                        })
                    }
                </tbody>
            </table>

            <table>
                <thead>
                    <tr>
                        <th>タグ</th>
                        <th>コンテキスト</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        debugTagList?.map((field, index) => {
                            return (
                                <>
                                    <tr>
                                        <td>{field.tags.join(",")}</td>
                                        <td>{field.context}</td>
                                    </tr>
                                </>
                            );
                        })
                    }
                </tbody>
            </table>

            <form onSubmit={(e) => { handleSubmit(onSubmit)(e) }}>
                <div>
                    <Controller
                        name="sendMessage"
                        control={control}
                        render={({ field }) => (
                            isLoading ?
                                <div><OnsiteProgress></OnsiteProgress></div>
                                :
                                <TextareaAutosize
                                    {...field}
                                    {...register}
                                    minRows="8"
                                    maxRows="8"
                                    maxLength={500}
                                />
                        )}
                    />
                </div>
                <button type="submit">送信</button>
                <Button type="button"
                    onClick={(e) => {
                        setDebugTagList(getTagData(['画像認識', 'ライセンス']));
                    }}
                >テスト</Button>
            </form>
        </>
    )
}   